import { render } from "./OnboardingBoards.vue?vue&type=template&id=4ee3daf4&scoped=true"
import script from "./OnboardingBoards.vue?vue&type=script&lang=js"
export * from "./OnboardingBoards.vue?vue&type=script&lang=js"

import "./OnboardingBoards.vue?vue&type=style&index=0&id=4ee3daf4&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee3daf4"]])

export default __exports__